import {
	MobiPointsQueueEventAbstractEvent,
	EVENT_TYPE_START_TRACKING, EVENT_TYPE_END_TRACKING
} from "@/mobipoints/queue/event/abstract_event.type";

export class MobiPointsQueueEventTypeEndTrackingEvent extends MobiPointsQueueEventAbstractEvent
{

	getEventType(): string {
		return EVENT_TYPE_END_TRACKING;
	}

}